// The kukri: "Knife - Kukri | GameReady, PBR" by snji (sketchfab.com/snji, CC-BY-4.0), split by
// scripts/import-kukri.mjs into the grip, the guard and the blade. Held with the index finger behind
// the guard and the blade forward, curving down; its inspect turns the wrist to stand the blade up.

import * as THREE from 'three';
import { straightKnifeLoader } from './straightKnife';

export const loadKukri = straightKnifeLoader({
  url: `${import.meta.env.BASE_URL ?? '/'}assets/models/kukri.glb`,
  colors: { grip: 0x0e0f12, guard: 0x1d1f24 },
  fitScale: 0.005,
  index: { part: 'guard', from: 'middle', offset: 30 },
  fistLength: 640,
  edgeSide: -1,
  inspect: {
    fist: new THREE.Vector3(0.06, -0.08, -0.5),
    across: new THREE.Vector3(-0.2, -1, 0.05),
    knuckles: new THREE.Vector3(-0.2, 0.1, -0.95),
    palm: false,
  },
});
